import { createClient } from "@smfa/utils";
const baseUrl = process.env?.API_URL || process.env?.REACT_APP_BACKEND_URL;
const axios = createClient({ baseUrl, isAdminSite: true });

export const getPatientBanner = (data) =>
  axios.get("/get_patient_banner", data ? { params: data } : {});

export const getPatientIntroduction = (data) =>
  axios.get("/get_patient_introduction", data ? { params: data } : {});

export const getPatientQueAnsList = (data) =>
  axios.post("/get_patient_que_ans_list", data);

export const addEditPatientBanner = (data) =>
  axios.post("/add_edit_patient_banner", data);

export const addEditPatientIntro = (data) =>
  axios.post("/add_edit_patient_intro", data);

export const addEditPatientQueAns = (data) =>
  axios.post("/add_edit_patient_que_ans", data);

export const deletepatient = (data) =>
  axios.post(`/delete_patient_que_ans`, data);
